import React, { Fragment, useState } from "react"
import { GenericDialog } from "../../../components/generic/GenericDialog"
import { FormTextField } from "../../../components/generic/GenericTextFields";
import { DECLINE_CHECKLIST, MAX_CHAR_BIO, REQUEST_EDIT_FIELDS, DECLINE_FIELDS } from "../../../enums/generalEnums";
import { Box, Button, FormControlLabel, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { GenericCheckBox } from "../../../components/generic/GenericCheckBox";
import LoadingButton from "@mui/lab/LoadingButton";
import { addRemoveArray } from "../../../helpers/arrayHelper";
import { declineUser, requestEdit } from "../../../config/apisauce";
import useNotiStack from "../../../hooks/useNotiStack";
import { DECLINE } from "../../../enums/statusEnums";

export const ReasonDialog = (props) => {
  const {
    openDialog,
    dialogDetails,
    handleCloseDialog,
  } = props;

  const { error, success } = useNotiStack();
  const [checkedList, setCheckedList] = useState([]);
  const [details, setDetails] = useState('');
  const [loading, setLoading] = useState(false);
  const maxCharacters = MAX_CHAR_BIO - (details?.length ?? 0);

  const handleSelectFromList = (id, isAdd = true) => {
    setCheckedList((prev) => addRemoveArray(prev, isAdd, id));
  };

  const handleClear = () => {
    handleCloseDialog();
    setDetails('');
    setCheckedList([]);
  };

  const handleSubmit = async () => {
    const fieldType = dialogDetails?.action === DECLINE ? DECLINE_FIELDS : REQUEST_EDIT_FIELDS;
    if (details) {
      setLoading(true);
      const fields = Object.values(fieldType === DECLINE_FIELDS ? DECLINE_CHECKLIST : [])?.map((item) => {
        return ({
          name: item,
          checked: checkedList?.includes(item),
          type: fieldType
        })
      });
      const params = {
        user_id: dialogDetails?.data?.id,
        email: dialogDetails?.data?.email,
        name: dialogDetails?.data?.name ?? dialogDetails?.data?.email,
        fields: {
          [fieldType]: fields,
          details: details
        }
      };
      const response = dialogDetails?.action === DECLINE ? await declineUser(params) : await requestEdit(params);
      if (response.ok) {
        handleClear();
        success('Submitted successfully!');
      }
      setLoading(false);
    } else {
      error('Please provide more details');
    }
  }

  return (
    <GenericDialog
      title={`Reasons for ${dialogDetails?.label ?? ''}`}
      openDialog={openDialog}
      handleClose={handleClear}
      width={'850px'}
    >
      {
        dialogDetails?.checklists?.length > 0 && <Fragment>
          <Typography fontWeight={700}>Choose between the following:</Typography>
          <Box sx={{ padding: '0px 24px', margin: '10px 0' }}>
            <Grid container>
              {
                Object.values(dialogDetails?.checklists ?? [])?.map((checklist, index) => {
                  return (
                    <Grid item size={{ xs: 12, md: 4 }} key={`checklist-key-${index}`}>
                      <FormControlLabel
                        control={
                          <GenericCheckBox
                            onChange={(event) => handleSelectFromList(checklist, event.target.checked)}
                          />
                        }
                        label={checklist} />
                    </Grid>
                  )
                })
              }
            </Grid>
          </Box>
        </Fragment>
      }
      <FormTextField
        value={details}
        color={'text.main'}
        isRequired={false}
        placeholder={'Type here...'}
        label={'Provide more details:'}
        multiline={true}
        rows={7}
        handleChange={(value) => {
          if (value.length <= MAX_CHAR_BIO) {
            setDetails(value);
          }
        }}
      />
      <Typography fontSize={'10px'} color={maxCharacters <= 50 ? "error" : "grey.dark"} mt={1}>{`${maxCharacters} characters left`}</Typography>
      <Stack justifyContent={'end'} direction={'row'} mt={3} gap={1}>
        <Button variant="outlined" sx={{ width: '250px' }} onClick={() => handleClear()}>Cancel</Button>
        <LoadingButton
          onClick={() => handleSubmit()}
          size="small"
          loading={loading}
          variant="contained"
          disabled={loading}
          sx={{ color: '#FFF', width: { xs: '100%', sm: '250px' } }}
        >
          Submit
        </LoadingButton>
      </Stack>
    </GenericDialog>
  )
}